import { render, staticRenderFns } from "./User2company.vue?vue&type=template&id=bcda08fe&"
import script from "./User2company.vue?vue&type=script&lang=js&"
export * from "./User2company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports